import React from 'react';
import {useTranslation} from 'react-i18next';
import {editSidebarElementTranslationKey, elementGroups} from '../../../../../constants/elementGroups';
import {useAddElementAction} from '../../../../../context/AddElementsContext';
import Button from '../../../../../incase-domain/components/button/Button';
import DropdownMenuCompact, {
    DropdownMenuCompactMenuPosition,
} from '../../../../../incase-domain/components/dropdownMenuCompact/DropdownMenuCompact';
import TooltipWrapper from '../../../../components/common/TooltipWrapper';

function FloatingElements(): JSX.Element {
    const {t} = useTranslation();
    const addElement = useAddElementAction();

    return (
        <>
            <div className="c-floatingElements">
                {elementGroups.map((group) => (
                    <div className="u-flex u-v-center" key={group.label}>
                        <TooltipWrapper
                            id={t(editSidebarElementTranslationKey(group.items[0].label))}
                            content={`${t(editSidebarElementTranslationKey(group.items[0].label))}${
                                group.items[0].shortcut ? ` (${group.items[0].shortcut.join('+').toUpperCase()})` : ''
                            }`}
                        >
                            <Button
                                className="c-floatingElements__button"
                                leading={group.icon}
                                size="xs"
                                variant="ghost"
                                color="secondary"
                                square
                                onClick={() => addElement(group.items[0].type, group.items[0].elementProps)}
                            />
                        </TooltipWrapper>
                        <DropdownMenuCompact
                            key={group.label}
                            items={[
                                group.items.map((item) => ({
                                    label: t(editSidebarElementTranslationKey(item.label)),
                                    icon: item.icon,
                                    type: item.type,
                                    elementProps: item.elementProps,
                                    onClick: () => addElement(item.type, item.elementProps),
                                    shortcuts: item.shortcut,
                                })),
                            ]}
                            menuPosition={DropdownMenuCompactMenuPosition.UP}
                        >
                            <Button
                                className="c-floatingElements__dropdownButton"
                                leading="ph:caret-down-bold"
                                size="xs"
                                variant="ghost"
                                color="secondary"
                                square
                            />
                        </DropdownMenuCompact>
                    </div>
                ))}
            </div>
        </>
    );
}

export default FloatingElements;
